import { API_ROUTES } from "@/constants/apiRoutes";
import { IUserProfile } from "@/models/userProfile.model";
import { httpRequestServer } from "@/services/httpRequestServer";

export const userProfileDataService = {
  getCurrentAsync: async (): Promise<IUserProfile> => {
    return await httpRequestServer.get(`${API_ROUTES.USER_PROFILE}/current`);
  }
};